import {
  ALERT_COPY_COLUMN_CLASS_MAP,
  ALERT_ASSET_GRID_CLASS_MAP,
  TAlertAsset,
  TAlertOrientation,
  ALERT_ORIENTATION_GRID_CLASS_MAP,
} from "./Alert.config";
import { isAlertAssetIconKey, isAlertAssetImage } from "./Alert.guards";

export const getAlertAssetGridClass = (asset: TAlertAsset | undefined) => {
  if (!asset) { return ALERT_ASSET_GRID_CLASS_MAP.default; }
  if (isAlertAssetImage(asset)) { return ALERT_ASSET_GRID_CLASS_MAP.withImage; }
  if (isAlertAssetIconKey(asset)) { return ALERT_ASSET_GRID_CLASS_MAP.withIcon; }
  return ALERT_ASSET_GRID_CLASS_MAP.default;
};

export const getAlertOrientationGridClass = (orientation: TAlertOrientation | undefined) => {
  if (!orientation) { return ALERT_ORIENTATION_GRID_CLASS_MAP.default; }
  return ALERT_ORIENTATION_GRID_CLASS_MAP[orientation];
};

export const getAlertCopyColumnClass = (asset: TAlertAsset | undefined) => (
  asset ? ALERT_COPY_COLUMN_CLASS_MAP.withAsset : ALERT_COPY_COLUMN_CLASS_MAP.default
);
